import styled from "styled-components";

export const FormContainer = styled("div")`
  #root_ticker {
    width: 60px;
  }

  #root_mapTo {
    width: 160px;
  }
`;

export const TitleStyled = styled.h1`
  font-size: 20px;
  line-height: 36px;
  margin: 0;
  font-family: inherit;
  font-weight: 600;
  color: inherit;
  text-rendering: optimizeLegibility;
`;

export const ParagraphStyled = styled.p`
  font-size: "18px";
  line-height: "2.2em";
  color: "#6b6b6b";
  background-color: "#e4e4e4";
  text-align: "center";
`;

export const TitleSectionStyled = styled.span`
  font-weight: 600;
`;

export const ContainerSection = styled.div`
  padding: 20px;
`;

export const ContainerMenuItemStyled = styled.div`
  background-color: var(--secondary);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 4px;

  .dropdown-item {
    display: flex;
    text-transform: none;
    font-size: 14px;
    line-height: 18px;
    margin: 0;
    font-family: inherit;
    font-weight: 600;
    color: var(--secondary);
    text-rendering: optimizeLegibility;
    padding: 0.3rem 0.5rem;
    color: white;
    padding: 8px;
    margin-bottom: 4px;

    &:hover {
      background-color: var(--secondary);
    }
  }
`;
